<template>
    <div class="unit-group">
        <ul>
            <li :class="{[typeToClass(type)]: true}"
                v-for="(unit, i) in groupedUnits"
                :key="`${unit.type}-${i}`"
            >
                <unit :unit="unit"/>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'UnitGroup',
    props: ['player', 'units', 'type', 'stack'],
    computed: {
        groupedUnits() {
            let quantity;

            if (!this.stack) {
                return this.units.map((unit) => {
                    quantity = 1 + (unit.bolsterUnits ? unit.bolsterUnits.length : 0);
                    return { ...unit, quantity };
                });
            }

            const unitsByType = {};

            for (const unit of this.units) {
                if (typeof unitsByType[unit.type] === 'undefined') {
                    unit.quantity = 1;
                    unitsByType[unit.type] = unit;
                } else {
                    unitsByType[unit.type].quantity += 1;
                }
            }

            return unitsByType;
        },
    },
    methods: {
        typeToClass(text) {
            return text.split(' ').map(word => word.toLowerCase()).join('-');
        },
    },
};
</script>

<style scoped lang="scss">

    .unit-group {
        display: inline-block;
        position: relative;
        align-self: center;

        ul {
            padding: 0;
            margin: 0;
            list-style-type: none;

            li {
                display: inline;

                &:not(:last-of-type) {
                    margin-right: 15px;
                }
            }
        }

        .unit-group-type {
            margin-top: 15px;
        }
    }

    .player-mat {

        .unit-group {

            &:not(:last-of-type) {
                margin-right: 50px;
            }
        }

        &.right,
        &.left {
            .unit-group {

                ul {
                    li {
                        display: block;
                        margin-right: 0;
                    }
                }
            }
        }
    }

</style>
